import { getDataSource, getMe, getPhysiciansAndEkgStackCount } from '../../store/appReducer'
import { DATASOURCES, CLEAR_STATE } from '../../constants'

// ------------------------------------
// Constants
// ------------------------------------

// ------------------------------------
// Actions
// ------------------------------------

export const getNavigationSidebarData = () => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)

  let promises

  if (meDataSource.data) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  return promises
    .catch(err => {
      console.log('getNavigationSidebarData', err)
    })
}

// const initialState = {
//   dashboard: true,
// }

// ------------------------------------
// Action Handlers
// ------------------------------------
// const ACTION_HANDLERS = {
//   [CLEAR_STATE]: (state, action) => ({ ...initialState }),
// }

// ------------------------------------
// Reducer
// ------------------------------------
// export default function dashboardReducer(state = initialState, action) {
//   const handler = ACTION_HANDLERS[action.type]
//   return handler ? handler(state, action) : state
// }



// WEBPACK FOOTER //
// ./src/legacy/containers/NavigationSidebar/module.js